import type { Locale } from "@repo/fika-shared/src/locale.js"
import type { FragmentOf, ResultOf, TadaDocumentNode } from "gql.tada"
import { initGraphQLTada, readFragment } from "gql.tada"
import { type Accessor, createMemo } from "solid-js"
import type { introspection } from "./graphql-env.ts"

export const graphql = initGraphQLTada<{
  introspection: typeof introspection
  scalars: {
    DateTime: Date
    Locale: Locale
  }
}>()

export type { FragmentOf, ResultOf, VariablesOf } from "gql.tada"
export { readFragment }

function createFragment<TFragment extends TadaDocumentNode<any, any, any>>(
  fragment: TFragment,
  data: () => FragmentOf<TFragment>,
): Accessor<ResultOf<TFragment>>
function createFragment<TFragment extends TadaDocumentNode<any, any, any>>(
  fragment: TFragment,
  data: () => FragmentOf<TFragment> | null | undefined,
): Accessor<ResultOf<TFragment> | null | undefined>
function createFragment<TFragment extends TadaDocumentNode<any, any, any>>(
  fragment: TFragment,
  data: () => FragmentOf<TFragment> | null | undefined,
): Accessor<ResultOf<TFragment> | null | undefined> {
  return createMemo(() => {
    return readFragment(fragment, data())
  })
}

export { createFragment }
